import { useApp } from '../context/AppContext';
import { trpc } from '../lib/trpc';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';

export function DashboardScreen() {
    const { selectedBranchId } = useApp();
    const navigate = useNavigate();
    const today = format(new Date(), 'yyyy-MM-dd');

    const { data: seatsData } = trpc.listSeats.useQuery(
        { date: today, branchId: selectedBranchId! },
        { enabled: !!selectedBranchId }
    );

    const { data: endingSoon } = trpc.listEndingSoonSubscriptions.useQuery(
        { branchId: selectedBranchId!, days: 7 },
        { enabled: !!selectedBranchId }
    );

    // Calc simple stats
    const totalSeats = seatsData?.seats.length || 0;
    const totalShifts = (seatsData?.shifts.length || 0) * totalSeats;
    const bookedCount = seatsData?.bookings.length || 0;
    const occupancyRate = totalShifts ? Math.round((bookedCount / totalShifts) * 100) : 0;

    if (!selectedBranchId) return <div className="p-8 text-center text-muted-foreground">Select a branch.</div>;

    return (
        <div className="space-y-6 pb-20">
            <h2 className="text-2xl font-bold px-1">Dashboard</h2>

            <div className="grid grid-cols-2 gap-4">
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium text-muted-foreground">Occupancy</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold">{occupancyRate}%</div>
                        <p className="text-xs text-muted-foreground">Today's utilization</p>
                    </CardContent>
                </Card>
                <Card>
                    <CardHeader className="pb-2">
                        <CardTitle className="text-sm font-medium text-muted-foreground">Active Bookings</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold">{bookedCount}</div>
                        <p className="text-xs text-muted-foreground">Across {seatsData?.shifts.length} shifts</p>
                    </CardContent>
                </Card>
            </div>

            <div>
                <h3 className="text-lg font-semibold mb-3 px-1">Ending Soon</h3>
                <div className="space-y-3">
                    {endingSoon?.map(sub => (
                        <Card key={sub.id} className="border-0 shadow-sm cursor-pointer hover:bg-muted/50 transition-colors" onClick={() => navigate(`/users/${sub.user_id}`)}>
                            <CardContent className="p-4 flex justify-between items-center">
                                <div>
                                    <div className="font-semibold">{sub.user_name}</div>
                                    <div className="text-xs text-muted-foreground">
                                        Seat {sub.seat_number} • {sub.shift_name}
                                    </div>
                                </div>
                                <div className="text-right">
                                    <div className="text-sm font-bold text-red-500">
                                        {format(new Date(sub.end_date), 'd MMM')}
                                    </div>
                                    <div className="text-xs text-muted-foreground">Expires</div>
                                </div>
                            </CardContent>
                        </Card>
                    ))}
                    {!endingSoon?.length && (
                        <div className="text-sm text-muted-foreground px-1">No subscriptions ending soon.</div>
                    )}
                </div>
            </div>
        </div>
    );
}
